import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { useDeleteDashboardEmployee } from 'api/hooks/use-dashboard-employees'
import { useQueryClient } from 'react-query'

function DeleteEmployee({ addOrRemoveEmployee, employee, dashboardId, canEdit = true }) {
  const queryClient = useQueryClient()
  const { mutate } = useDeleteDashboardEmployee({
    id: employee.dashboard_employee_id,
    options: {
      onSuccess: () => {
        addOrRemoveEmployee(employee)
        queryClient.invalidateQueries(
          `dashboards/${dashboardId}`
        )
        queryClient.invalidateQueries('dashboards')
      }
    }
  })

  const handleDelete = () => {
    if (!canEdit) return
    // Delete via API if persisted, otherwise remove from staged local state
    if (employee.dashboard_employee_id) {
      mutate()
    } else {
      addOrRemoveEmployee(employee)
    }
  }

  return (
    <button
      className="btn btn-sm btn-link text-danger"
      onClick={handleDelete}
      disabled={!canEdit}
    >
      <FontAwesomeIcon icon={faTrash} />
    </button>
  )
}

export default DeleteEmployee